module.exports = __webpack_public_path__ + "static/media/signup-contractor.e8a7983f.png";